let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("26W0c")).then(() => parcelRequire('eUCn3'));